import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppValidators } from 'src/app/common/appValidators';
import { PolicyModel } from 'src/app/models/api/governance/policy.model';

@Component({
  selector: 'app-add-endpoint-dialog',
  templateUrl: './add-endpoint-dialog.component.html',
  styleUrls: ['./add-endpoint-dialog.component.scss'],
})
export class AddEndpointDialogComponent implements OnInit {
  public waitingForResponse = false;
  public addEndpointsFormGroup: UntypedFormGroup;

  public readonly maxHostnamesToAdd = 10;

  constructor(
    public dialogRef: MatDialogRef<AddEndpointDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public policyData: PolicyModel,
    private readonly _formBuilder: UntypedFormBuilder
  ) {}

  public get endpointsToAdd(): UntypedFormArray {
    return this.addEndpointsFormGroup.get('endpointsToAdd') as UntypedFormArray;
  }

  ngOnInit(): void {
    this.addEndpointsFormGroup = this._formBuilder.group({
      endpointsToAdd: this._formBuilder.array(
        [
          this._formBuilder.group({
            url: this._formBuilder.control('', [AppValidators.urlWithPathParams, Validators.required]),
          }),
        ],
        [AppValidators.maxHostnames(this.maxHostnamesToAdd), AppValidators.uniqueEndpointFromPolicy(this.policyData)]
      ),
    });
  }

  public addMoreClicked() {
    const domains = this.endpointsToAdd;
    if (domains.length < this.maxHostnamesToAdd) {
      domains.push(
        this._formBuilder.group({
          url: this._formBuilder.control('', [AppValidators.urlWithPathParams, Validators.required]),
        })
      );
    }
  }

  public removeEndpoint(indexToRemove: number) {
    if (0 < indexToRemove && indexToRemove < this.endpointsToAdd.length) {
      this.endpointsToAdd.removeAt(indexToRemove);
    }
  }

  public addEndpoint() {
    if (!this.waitingForResponse) {
      this.waitingForResponse = true;
      this.dialogRef.close(this.addEndpointsFormGroup.value.endpointsToAdd);
    }
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
